export const TERMS_TEXT = `A SHADE GREENER MAINTENANCE LIMITED Consent Terms

A SHADE GREENER MAINTENANCE LIMITED requests your consent to access, store and process your energy consumption, export and tariff information. If you agree, the following information will be requested from your smart meter on a daily or more frequent basis:

Energy consumption & generation information for both gas and electricity (where available)
Energy tariff information containing details of the price you are charged for energy consumed
Information identifying the energy meter (number, location, type)

The granularity of data gathered is at 30-minute intervals. Your consent is valid for a period of 12 months, after which you will be required to consent again. You can withdraw consent at any time via the consumer portal, as detailed later in this document.

A SHADE GREENER MAINTENANCE LIMITED uses data services provided under the Smart Energy Code via A SHADE GREENER MAINTENANCE LIMITED, incorporated and registered in England and Wales with company number 08584260, whose registered office is:

Sterling House, Maple Court, Maple Road, Tankersley, England, S75 3DP

A SHADE GREENER MAINTENANCE LIMITED provides the service of gathering and processing energy data to deliver insights, monitoring, and related services. Each time your data is accessed or used, it will be done in accordance with your consent and applicable terms.

A SHADE GREENER MAINTENANCE LIMITED only processes data necessary to provide its services and will not collect unnecessary personal contact information. The duration for which your data is stored and processed will be clearly defined and aligned with the services you receive.

A SHADE GREENER MAINTENANCE LIMITED provides visibility and control of the information you have shared via a consumer interface where you can:

Review what data access has been granted
Download a copy of your data
Withdraw consent at any time

If consent is withdrawn, A SHADE GREENER MAINTENANCE LIMITED will remove all identifiable data from its active platforms, subject to legal and regulatory obligations.

All consumption, generation and tariff information may be anonymised and aggregated into datasets used to improve energy services, efficiency, and sustainability. This data will not identify you personally.

Due to the nature of anonymisation, it is not possible to identify your data within aggregated datasets, and therefore it cannot be removed once included.`;
